import { useEffect, useState } from 'react'
import { createLeadsMarketingTeam, countryList } from "../../../../Context/api";
import { leadAddValidation } from '../../../../Context/validation';
import axios from "axios";
import { commonMessage, statusCodes } from "../../../../Constants/generalConfig";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useFormik } from 'formik';
import { isValidPhoneNumber } from 'react-phone-number-input';


const UseAddLead = () => {
    const [spinner, setSpinner] = useState(false)
    const [countryData, setCountryData] = useState([])

    const adminData = JSON.parse(localStorage.getItem('adminData'));
    const navigate = useNavigate()

    useEffect(() => {
        countryListData()
    }, [])
    const countryListData = () => {
        const data = {
            id: adminData.userId,
            isDeleted: true,
            isActive: true,
            searchText: '',
            page: 1,
            count: 100
        }

        axios.post(countryList(), { ...data }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setCountryData(resp.data.data)

            }

            else {
                setCountryData([])


            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
                setSpinner(false)
            })
    }
    const leadAdd = useFormik({
        initialValues: {
            name: '',
            email: '',
            mobileNo: '',
            providerName: '',
            description: '',
            country: ''
        },
        validationSchema: leadAddValidation,
        validate: (values) => {
            const errors = {};
            if (values?.mobileNo?.length > 0 && (values?.mobileNo && isValidPhoneNumber(values?.mobileNo))) {
                delete errors.mobileNo
            } else {
                errors.mobileNo = "Please enter a valid mobile number ";
            }
            return errors;
        },
        onSubmit: (values) => {
            const data = {
                name: values.name.trim(),
                email: values.email.trim(),
                providerName: values.providerName.trim(),
                createdbyId: adminData?.userId,
                description: values.description.trim(),
                mobileNo: values.mobileNo.toString().trim(),
                country: values.country
            }
            // console.log(data, 'lllll')
            setSpinner(true)
            axios.post(createLeadsMarketingTeam(), data).then((resp) => {
                if (resp.data.code === statusCodes.ok) {
                    leadAdd.resetForm()
                    toast.success(resp.data.message)
                    setSpinner(false)
                    setTimeout(() => {
                        navigate(-1)
                    }, 1000);
                }
                else {
                    toast.error(resp.data.message)
                    setSpinner(false)
                }
            })
                .catch(() => {
                    toast.error(commonMessage.networkError)
                    setSpinner(false)
                })
        }
    })
    return {
        spinner,
        leadAdd,
        countryData,
    }
}

export default UseAddLead